import { put, call, all, takeEvery } from 'redux-saga/effects'
import {
	userLoadDataRequest,
	userLoadDataSuccess,
	userLoadDataFailure,
	userLogInRequest,
	userLogInSuccess,
	userLogInFailure,
	userLogOutRequest,
	userLogOutSuccess,
	userLogOutFailure
} from '../actions'

import history from '../history'
import { apiRequest, lcApiRequest, removeCookie, waitForState } from 'utils'
import { redirectToAccounts, setupChatWindow } from '../utils'

function* loginUser({ payload: { token } }) {
	try {
		const response = yield call(() => {
			return apiRequest(token, '/account/login', 'post')
		})
		if (response.ok) {
			yield history.replace({}, document.title, '.')
			const firstLogin = yield response.status === 201 ? true : false
			yield put(userLoadDataRequest({ token }))
			yield put(
				userLogInSuccess({
					token,
					firstLogin,
					loggedInAt: Date.now()
				})
			)
		} else {
			throw new Error('There is no such user.')
		}
	} catch (error) {
		yield put(userLogInFailure({ error }))
	}
}
function* handleLogInFailure({ payload }) {
	yield removeCookie('access_token')
	yield call(() => {
		redirectToAccounts()
	})
}

function* logoutUser() {
	try {
		yield removeCookie('access_token')
		yield put(userLogOutSuccess({ loggedOutAt: Date.now() }))
		yield call(() => {
			redirectToAccounts('/signout')
		})
	} catch (error) {
		yield put(userLogOutFailure({ error }))
	}
}

function* fetchUser({ payload }) {
	const userMeta = yield call(waitForState, state => state.user.meta)

	try {
		const user = yield call(() => {
			return lcApiRequest(payload.token, '/agents/me', 'get')
		})

		if (user.ok) {
			const userJson = yield call(() => user.json())

			const payload = {
				meta: userJson,
				receivedAt: Date.now()
			}

			yield put(userLoadDataSuccess(payload))

			const [userName, userEmail] = yield all([
				userMeta.name,
				userMeta.login
			])

			yield call(() => setupChatWindow({ userName, userEmail }))
		} else {
			throw new Error('There is no data for this user.')
		}
	} catch (error) {
		yield console.log(error)
		yield put(userLoadDataFailure({ error }))
	}
}

// function* identifyUserWithAmplitude() {
// 	yield call(() => {
// 		const amplitude = window.amplitude || {}
// 		const identify = new amplitude.Identify().setOnce()
// 		amplitude.getInstance().identify(identify)
// 	})
// }

export function* watchUserRequests() {
	yield takeEvery(userLogInRequest, loginUser)
	yield takeEvery(userLogInFailure, handleLogInFailure)
	yield takeEvery(userLogOutRequest, logoutUser)
	yield takeEvery(userLoadDataRequest, fetchUser)
	// yield takeEvery(userLogInSuccess, identifyUserWithAmplitude)
}



// WEBPACK FOOTER //
// ./src/sagas/users.js